import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-564efb9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { id: "about2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topback" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "zwbs" }),
  /*#__PURE__*/_createElementVNode("div", { class: "zwbsText" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "zwbsLeft" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "doudou" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "zwbsRight" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "lineOne" }, "病程中全身皮肤干痒，皮疹分布对称"),
      /*#__PURE__*/_createElementVNode("div", { class: "lineOne" }, "严重时曾出现黄水结痂"),
      /*#__PURE__*/_createElementVNode("div", { class: "lineOne" }, "儿女有过敏性鼻炎和湿疹病史")
    ])
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wenhao" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wenhaoTxt" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "txt1" }, "以下哪些因素可能是湿疹加重或"),
    /*#__PURE__*/_createElementVNode("div", { class: "txt1" }, "反复发作的原因？")
  ])
], -1))
const _hoisted_5 = { class: "zljg" }
const _hoisted_6 = { class: "radioBox" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "bottomBox" }
const _hoisted_11 = {
  key: 0,
  class: "swperList"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ip" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "2.3733rem",
        height: ".52rem",
        src: require('../assets/newlogo.png')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_van_popup, { show: true }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_van_checkbox_group, {
              modelValue: $data.checkVal,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.checkVal) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_van_checkbox, {
                    key: "1",
                    value: "1",
                    modelValue: $setup.checkedd,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.checkedd) = $event)),
                    name: "1"
                  }, {
                    icon: _withCtx((props) => [
                      _createElementVNode("img", {
                        class: "img-icon",
                        src: props.checked ? $data.activeIcon : $data.inactiveIcon
                      }, null, 8, _hoisted_7)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode("A.合并感染 ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_van_checkbox, {
                    key: "2",
                    value: "2",
                    modelValue: $setup.checkedd,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.checkedd) = $event)),
                    name: "2"
                  }, {
                    icon: _withCtx((props) => [
                      _createElementVNode("img", {
                        class: "img-icon",
                        src: props.checked ? $data.activeIcon : $data.inactiveIcon
                      }, null, 8, _hoisted_8)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode("B.可能为特应性皮炎 ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_van_checkbox, {
                    key: "3",
                    value: "3",
                    modelValue: $setup.checkedd,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.checkedd) = $event)),
                    name: "3"
                  }, {
                    icon: _withCtx((props) => [
                      _createElementVNode("img", {
                        class: "img-icon",
                        src: props.checked ? $data.activeIcon : $data.inactiveIcon
                      }, null, 8, _hoisted_9)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode("C.两者均是 ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_van_image, {
              onClick: $options.yanjiu,
              width: "3.9333rem",
              height: "1.1467rem",
              src: require('../assets/jiemi.png')
            }, null, 8, ["onClick", "src"])
          ]),
          ($props.postaimqus == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_van_image, {
                  width: "5.2667rem",
                  height: "4.8rem",
                  src: require('../assets/gongge.jpg')
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_van_popup, {
            show: _ctx.show,
            "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.show) = $event)),
            style: { padding: '64px' }
          }, {
            default: _withCtx(() => [
              _createTextVNode("内容")
            ]),
            _: 1
          }, 8, ["show"])
        ])
      ]),
      _: 1
    }),
    _hoisted_12,
    _hoisted_13,
    _createVNode(_component_toNav, { menu: 1 })
  ], 64))
}